import { matchPath, useLocation, useParams } from 'react-router-dom'

/**
 * Resolves a public-share route param from React Router context, falling back to
 * pathname matching when sibling public routes navigate outside the main App Routes tree.
 */
export function usePublicShareRouteParam(
  pattern: string,
  paramName: string,
  slugOverride?: string,
): string {
  const params = useParams<Record<string, string | undefined>>()
  const { pathname } = useLocation()
  const fromOverride = (slugOverride ?? '').trim()
  const fromParams = (params[paramName] ?? '').trim()
  const fromMatch = (matchPath(pattern, pathname)?.params[paramName] ?? '').trim()
  return fromOverride || fromParams || fromMatch
}
